const LOGO_BOTTOM_OFFSETS = {
  variant1: ['110px', '135px', '10px'],
  variant2: ['105px', '120px', '-10px']
}

export default LOGO_BOTTOM_OFFSETS
